define([
    "base/utils/preVerifycodeUtil",
    "base/utils/iamHttpService",
    "base/utils/iamValidator",
    "base/utils/utility"
], function (perVerifycodeUtil, iamHttpService, IAMValidator, utils) {
    const html = require("base/widgets/graphicVerifyWindow/window.html");
    function getOptions() {

        var width = "410px";
        var height = "250px";
        if (window.language != "zh-cn")
        {
            width = "550px";
            height = "280px";
        }
        return {
            height: height,
            width: width,
            content: html,
            "content-type": 'url',
            resizable: false,
            isMobile: false,
            isMobileApp:false      
        };
    }

    function addCssToPage(href) {
        var head = document.getElementsByTagName("head")[0];
        var cssLink = document.createElement("link");
        cssLink.type = "text/css";
        cssLink.rel = "stylesheet";
        cssLink.href = href;
        head.appendChild(cssLink);
    };
    function GraphicVerifyWindow(i18n, options, btnCallbacks, verifyCodeIndex) {
        var winOptions = getOptions();
        $.extend(true, winOptions, options);

        if(winOptions.isMobile == true || winOptions.isMobileApp == true){
            addCssToPage("/authui/public/base/mobile/css/graphVerCode.css");
        }
        if (winOptions.isMobile === true) {
            var width = 300;
            var height = 210;
            winOptions.width = width + "px";
            winOptions.height = height + "px"
        }
        if(winOptions.isMobileApp === true){
            var width = 300;
            var height = 210;
            winOptions.width = width + "px";
            winOptions.height = height + "px";
            winOptions.isMobile = true
        }

        var okCallbacks = $.Callbacks();
        var cancelCallbacks = $.Callbacks();
        if ($.isArray(btnCallbacks)) {
            okCallbacks.add(btnCallbacks[0]);
            btnCallbacks[1] && cancelCallbacks.add(btnCallbacks[1]);
        } else if ($.isFunction(btnCallbacks)) {
            okCallbacks.add(btnCallbacks);
        }

        var okBtnConfig = {
            key: "btnOK",
            label: i18n("btnTxtOK"),
            focused: true,
            handler: function () {
                $("#btnOK").addClass("DelHoverStyle");
                var iamValidator = new IAMValidator(i18n);
                if(!iamValidator.unifyValid.FormValid($("#GraphicsVerification")))
                {
                    iamValidator.unifyValid.focusFirst($("#GraphicsVerification"));
                    return;
                }
                
                var verifyCode = $("#graph_verifyCode").widget().getValue();
                if (verifyCode.length >= 4) {
                    okCallbacks.fire(verifyCode);
                }
            }
        };

        winOptions.buttons = [{
            key: "btnCancel",
            label: i18n("btnTxtCancel"),
            focused: false,
            handler: function () {
                cancelCallbacks.fire();
            }
        }];

        if (winOptions.isMobileApp === true) {
            winOptions.buttons.push(okBtnConfig);
        } else {
            winOptions.buttons.unshift(okBtnConfig);
        }

        $(document).keydown(function (event) {
            if(event.keyCode === 13) {
                var id = $(document.activeElement).attr("id");
                if (!id) {
                    id = $(document.activeElement.parentNode).attr("id");
                }
                if(id === "graph_verifyCode") {
                    $("#btnOK").click();
                }
            }
        });
        
        var window = new tinyWidget.Window(winOptions);
        okCallbacks.add(function () {
            window.destroy();
        });
        cancelCallbacks.add(function () {
            window.destroy();
        });
        this.window = window;

        initController(i18n, verifyCodeIndex, winOptions.isMobile);
    }

    GraphicVerifyWindow.prototype.show = function () {
        this.window.show();
        $(".overview").html(html);
    };

    function initController(i18n, index, isMobile) {
        var ctrl = function ($scope) {

            function getVerifyCode(index) {
                return "/authui/verifycode?index=" + index + "&alt=" + Math.random();
            }

            $scope.model = {
                inputId: "graph_verifyCode",
                focused: true,
                InputGrapVerifyCodeInfo: i18n("InputGrapVerifyCodeInfo"),
                GraphicsVerifyCode: i18n("GraphicsVerifyCodeLabel"),
                checkCodeTip: i18n("getVerifyCode"),
                verifyCodeSrc: getVerifyCode(index),
                verifyCode:"",
                tipPosition: "top",
                checkCodePH: "",
                isMobile: false,
                isMobileApp:false    
            };

            if (isMobile === true) {
                $scope.model.checkCodePH = i18n("verifyCodePlaceHolder");
                $scope.model.isMobile = true;
            }
            else {
                $scope.style = {
                    verifyCodeInfo: {"margin-left": "10%", "margin-top": "4%"},
                    verifyCodeContent: {"margin-left": "10%", "margin-top": "5%"}
                };
            }

            $scope.model.msgKeyPress=function(event){
                if (event.keyCode === 13) {
                    $("#btnOK").click();
                    $scope.$apply()
                }
            };
            var iamValidator = new IAMValidator(i18n);
            $scope.model.checkCodeValidator = [
                iamValidator.limitLength(4),
                iamValidator.notBlank(),
                iamValidator.maxLen(4)
            ];

            $scope.model.getVerifyCode = function(){
                $("#GrapVerifyCodeImg")[0].src = getVerifyCode(index);
                $("#"+$scope.model.inputId).widget().option("value", "");
                $("#validresultImg").hide();
            };

            $scope.model.preValidVerifyCode = function(event, value)
            {
                $("#" + $scope.model.inputId + " input").attr("maxLength", 4);
                var img = $("#validresultImg");
                perVerifycodeUtil.preValidVerifyCode(img, value, index, preValidCallback, iamHttpService);
            };

            function preValidCallback()
            {
                $("#"+$scope.model.inputId).widget().option("value", "");
                $scope.$apply();
                var verifyCodeImg = $("#GrapVerifyCodeImg")[0];
                if(verifyCodeImg)
                {
                    verifyCodeImg.src = getVerifyCode(index);
                }
            }

        };

        ctrl = ["$scope", ctrl];

        var iamModule = angular.module('authui.config');
        iamModule.controller('graphicVerifyCode.ctrl', ctrl);
    }

    return GraphicVerifyWindow;
});



// WEBPACK FOOTER //
// ./public/base/widgets/graphicVerifyWindow/window.js